import { Environment } from '@abp/ng.core';

const baseUrl = 'https://career-competencies-dev.upmuruguay.net';

const oAuthConfig = {
  issuer: 'https://career-competencies-backend-dev.upmuruguay.net/',
  redirectUri: baseUrl,
  clientId: 'CareerCompetencies_App',
  responseType: 'code',
  scope: 'offline_access CareerCompetencies',
  requireHttps: true,
  impersonation: {
    tenantImpersonation: true,
    userImpersonation: true,
  }
};

export const environment = {
  name: 'development',
  production: false,
  application: {
    baseUrl,
    name: 'CareerCompetencies',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://career-competencies-backend-dev.upmuruguay.net',
      rootNamespace: 'Upm.CareerCompetencies',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  appVersion: '0.0.1',
  grafana: {
    isEnabled: false,
    url: 'https://faro-collector-prod-sa-east-1.grafana.net/collect/3dc71cc5da8f4082551ed122fcad787b',
  },
} as Environment;
